module.exports = __webpack_public_path__ + "static/media/land-drawer-img--earth.e04d7dbf.png";